import { __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { useDisclosure } from './useDisclosure.js';
import { DisclosureProvider } from './DisclosureProvider.js';

var Disclosure = function (_a) {
    var id = _a.id, _b = _a.defaultIsOpen, defaultIsOpen = _b === void 0 ? false : _b, children = _a.children;
    var context = useDisclosure({
        id: id,
        defaultIsOpen: defaultIsOpen,
    });
    return (jsx(DisclosureProvider, __assign({ value: context }, { children: children instanceof Function ? children(context) : children })));
};

export { Disclosure };
//# sourceMappingURL=Disclosure.js.map
